/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { ConfigService } from '../services/configuration/config.service'

// ToDo: Delete this interceptor after IE-supports stops!
interface DocumentWithIEDocumentMode extends Document {
  documentMode?: number
}

@Injectable({
  providedIn: 'root',
})
export class IENoCacheHeaderInterceptor implements HttpInterceptor {
  private configService = inject(ConfigService)

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (
      !(window.document as DocumentWithIEDocumentMode).documentMode ||
      !req.url.startsWith(this.configService.getPublicApiConfig().baseUrl)
    ) {
      return next.handle(req)
    }

    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    })

    return next.handle(authReq)
  }
}
